import * as Sentry from '@sentry/browser';

if (process.env.REACT_APP_RUN_ENV === 'production') {
    Sentry.init({
        dsn: 'https://5f1edeb9bc4444aea166b40d30f8777c@sentry.corp.kuaishou.com/103',
        release: process.env.RELEASE,
        sampleRate: 0.3,
        environment: process.env.REACT_APP_RUN_ENV,
        integrations: [
            new Sentry.Integrations.GlobalHandlers({ onunhandledrejection: false, onerror: true }),
        ],
    });
}
